var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHojelogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 365.72 137.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#ffa357;}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:url(#linear-gradient-6);}.cls-8{fill:url(#linear-gradient-7);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -53.53,
    y1: 1129.38,
    x2: -2.53,
    y2: 1204.86,
    gradientTransform: "matrix(0.87, -0.5, 0.5, 0.87, -219.19, -982.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bffea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009b99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -99.42,
    y1: 1160.39,
    x2: -48.42,
    y2: 1235.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -73.46,
    y1: 1142.85,
    x2: -22.46,
    y2: 1218.32,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -108.12,
    y1: 1166.26,
    x2: -57.12,
    y2: 1241.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 49.5,
    y1: 154.96,
    x2: 22.61,
    y2: 59.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bffea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#12aca7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009b99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 132.7,
    y1: 149.89,
    x2: 104.32,
    y2: 55.05,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 170.85,
    y1: 144.08,
    x2: 150.27,
    y2: 47.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#6bffea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#2ec6bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009b99"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.18,71.7q.29-34.7.56-69.41a0,0,0,0,0,0,0,102.2,102.2,0,0,0-10,7.74c-12.67,12.36-22.36,26.45-24.8,43.6v0l34.22,18.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.63,55.8s0,0,0,0a59.41,59.41,0,0,0-.27,6.3c.21,26.56,13.33,46.64,34.39,62,0,0,0,0,0,0q.21-25,.41-50l0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.55,59.16a68.31,68.31,0,0,0-5-20.37l0,0H330.6a0,0,0,0,0,0,0L330,105.11s0,0,0,0L356.94,96a0,0,0,0,0,0,0A63.5,63.5,0,0,0,365.55,59.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M361.07,33C354.91,19,345.11,8.32,332.5,0l0,0q-.15,17.49-.29,35l0,0h29.71l0,0C361.66,34.32,361.37,33.65,361.07,33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M329.93,118.56h0a1.24,1.24,0,0,0,0,.33v15.59a1.34,1.34,0,0,0,1.16,1.37,1.28,1.28,0,0,0,1.39-1.28V123.29h0a95.55,95.55,0,0,0,18.06-18.1c1.59-2.09,3.06-4.22,4.43-6.38,0,0,0,0,0,0L330,107.27s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M48.5,60.4,29.22,42a2,2,0,0,0-2.83.06L12.28,56.84l-.08-.08L8.05,61.18a29.31,29.31,0,0,0-6.19,9.76A27.39,27.39,0,0,0,0,82.21,26.28,26.28,0,0,0,2.62,93.1a29.44,29.44,0,0,0,6.46,8.83,28.72,28.72,0,0,0,20.33,7.72,28.07,28.07,0,0,0,11.1-2.51,29.63,29.63,0,0,0,9-6.3,28.14,28.14,0,0,0,6-9.21,27.8,27.8,0,0,0,2-11.24A31.33,31.33,0,0,0,55,69.65,27.92,27.92,0,0,0,48.5,60.4ZM38.38,89.69a12.81,12.81,0,0,1-19.28,0,13.1,13.1,0,0,1,.9-17.8l7.29-7.29a2,2,0,0,1,2.89,0l7.29,7.29C42.29,76.71,42.88,84.56,38.38,89.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M133.49,109.4a33.18,33.18,0,0,0-6.7.65,20.56,20.56,0,0,0-16.05,18.89,25.27,25.27,0,0,0,.21,8.32c.24-.22.51-.43.74-.67-.23.24-.5.45-.74.67.56.67,1.4.44,2.06.49,5.35.37,10.55-.18,15.35-2.83,5.93-3.27,9.08-8.46,10.34-15,.13-.67.58-9.87-.14-10.3A40.43,40.43,0,0,0,133.49,109.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M257,51.36a7.77,7.77,0,0,0-2.12-2.16l-.21-.12-7.49-3.61-6.86-3.26c-2.44-1.14-4.71-2.22-6.87-3.25a32.72,32.72,0,0,0-13.86-3,29.93,29.93,0,0,0-17.23,4.93A38.55,38.55,0,0,0,190.69,53.8l-2.77,4.52a1.48,1.48,0,0,0,.57,2.07l14.76,7.85a1.46,1.46,0,0,0,1.89-.45l2.49-3.48c3.8-4.94,7.75-7.34,12.08-7.34a9.22,9.22,0,0,1,4.35,1l10.68,5a1.47,1.47,0,0,1,.53,2.24l-4.67,5.94a15.27,15.27,0,0,1-4.61,4,10.14,10.14,0,0,1-5,1.33h-48.5l-1.65,0c-.3,0-1.2,0-3.32,0a1.47,1.47,0,0,1-1.29-2.16c2.55-4.83,7.8-16.58,2.63-23.2a9.81,9.81,0,0,0-2.29-2.11l-.21-.12L145.4,39a32.65,32.65,0,0,0-13.87-3.11,30,30,0,0,0-17.31,5A39,39,0,0,0,102.51,53.8L99.7,58.39a1.48,1.48,0,0,0,.61,2.1l15.06,7.34a1.47,1.47,0,0,0,1.74-.33l2.47-2.71c1.5-1.59,2.85-3,4-4.14a16,16,0,0,1,2.73-2.24,9.24,9.24,0,0,1,2.42-1.09,11,11,0,0,1,2.94-.35,11.18,11.18,0,0,1,4.88,1L147,63a1.48,1.48,0,0,1,.54,2.23l-4.61,6c-2.88,3.54-6,5.26-9.56,5.26H97.8l-1.55-.07c-3-.16-6.1-.29-9.14-.43l.08-30.33a2.75,2.75,0,0,0-3.3-2.41,25.87,25.87,0,0,0-9.07,2.86c-1.44.78-8.51,4.64-8.95,10.37,0,.31,0,.55,0,.64.15,16.55.24,26.91,0,33.44-.59,16.33-3.51,36.17-4.14,40.29a.86.86,0,0,0,.79.92,21.4,21.4,0,0,0,8.11-.25,19.44,19.44,0,0,0,12.2-8.69s3.34-4.69,4.2-14.64h0l0-10.73c3.54-.07,6.89,0,10,.26a6.06,6.06,0,0,0,.75,0h35.42a35.35,35.35,0,0,0,13.28-3.31,40.79,40.79,0,0,0,6.76-4,1.46,1.46,0,0,1,1.93.18,22.46,22.46,0,0,0,17,7.09h48.93c11.28,0,20.21-4.58,26.53-13.59A53.55,53.55,0,0,0,258,58.09,8.85,8.85,0,0,0,257,51.36Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHojelogo);
export default __webpack_public_path__ + "static/media/hoje logo.b7196878aa7f476322a2e4d622d04275.svg";
export { ForwardRef as ReactComponent };